import api from "../services/api";
import { $Q, $Qll } from "../utils/query-selector";
import { stringToHTML } from "../utils/to-html";
import { cleanURL } from "./filter";
let intersectionObserver;
let PAGE_COUNT = 0;
let isFirstTime = true ;

/**
 * Initial event interceptor
 */
export const initialInfinityScroll = () => {
  intersectionObserver = new IntersectionObserver((entries) => {
    if (entries[0].boundingClientRect.bottom <= 0) return;

    if (entries[0].isIntersecting) {
      $Q("#loading-items").classList.remove("hidden");
      loadContentItems();
    }
  }, {
    rootMargin: '200px 0px 0px 0px'
  });

  const infinityScroll = $Q("#init-infinityscroll-js");
  if (!infinityScroll) return;

  intersectionObserver.observe(infinityScroll);
}

export const buildSearchURL = (currentUrl, currentUrlFilters, PAGE_COUNT) => {
  const paramsName = Object.keys(Shopify.queryParams)
  const paramsQuery = Object.values(Shopify.queryParams)
  const buildUrl = paramsName.map(((query, i) => `${query}=${paramsQuery[i]}`))
  .join('&')
  .replace(/ /g,'')

  return cleanURL(`${currentUrl}?${currentUrlFilters ? currentUrlFilters : buildUrl}${PAGE_COUNT ? `&page=${PAGE_COUNT}` : '' }`)
}

/**
 * load more content item paginate
 */

window.addEventListener('load', () => {
  if (window.location.href.includes('page=')) {
      const containerList = $Q('.item-list');
      containerList.innerHTML = ''; 
      const parts = window.location.href.split('&page')[0];;
      window.location.href = parts;
    }
});

const loadContentItems = async () => {
  const config = $Q("#data-config");
  const { currentPage, currentUrl, currentUrlFilters, section, container, item } = config.dataset;
  
  if (currentUrl === '/search' && isFirstTime == true) {
    let currentDataPage = Number(currentPage) + 1 ;
    PAGE_COUNT = currentDataPage + 1;
    isFirstTime = false;
  } else {
    PAGE_COUNT = Number(currentPage) + 1;
  }

  let BASE = cleanURL(`${currentUrl}${currentUrlFilters ? currentUrlFilters : '?'}&page=${PAGE_COUNT}`);
  if (currentUrl === '/search') BASE = buildSearchURL(currentUrl, currentUrlFilters, PAGE_COUNT)

  const URL_TO_UPDATE_HISTORY = BASE.split(currentUrl)[1]
  const oldScroll = window.scrollY;

  const response = await getMoreItem(BASE, section);

  if (response && config.getBoundingClientRect().top >= -50) {
    const containerList = $Q(container, stringToHTML(response));

    const listItems = $Qll(item, containerList);
    config.dataset.currentPage = Number($Q("#data-config", stringToHTML(response)).dataset.currentPage);

    if (listItems.length === 0) {
      $Q("#loading-items").classList.add("hidden");
      intersectionObserver.disconnect();
      return;
    }

    listItems.forEach((item) => {
      $Q(container).appendChild(item);
    });

    window.history.pushState(null, "", `${cleanURL(URL_TO_UPDATE_HISTORY)}`);
  } else {
    $Q("#loading-items").classList.add("hidden");
  }
}

const getMoreItem = async (BASE, section) => {
  const result = await api.shopifySectionByUrl(BASE, section, '&section_id');
  return result;
}
